<template>
  <div>
    <div class="header flex-between">
      <div class="header-text">
        <h1>已发券管理</h1>
      </div>
      <div class="header-button">
        <el-button
          v-if="jurisdiction.search"
          icon="el-icon-search"
          @click="query"
          >查询</el-button
        >
        <el-button
          v-if="jurisdiction.manual"
          icon="el-icon-edit-outline"
          @click="WriteOff"
          >手工核销</el-button
        >
        <el-button
          v-if="jurisdiction.disable"
          icon="el-icon-edit-outline"
          @click="Disable"
          >禁用</el-button
        >
        <el-button
          v-if="jurisdiction.synchronizationn"
          icon="el-icon-edit-outline"
          @click="Synchronization"
          >同步</el-button
        >
        <el-button
          v-if="jurisdiction.look"
          icon="el-icon-edit-outline"
          @click="see"
          >查看</el-button
        >
      </div>
    </div>
    <!-- 同步提示框 -->
    <div class="Enabledisable">
      <el-dialog
        width="20%"
        title="同步提示框"
        :visible.sync="EnabledisableFormVisible"
        :close-on-click-modal="false"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否真的要<span style="color: #ff0000">同步</span>此券?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="Enabledisableqd">确 定</el-button>
          <el-button @click="EnabledisableFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <el-card shadow="never">
      <div>
        <el-form label-width="100px" :model="page"  size="small">
          <el-row :gutter="50">
            <el-col :span="8">
          <el-form-item label="会员姓名/卡号/手机">
            <el-input v-model="page.search" placeholder="会员姓名/卡号/手机号"></el-input>
          </el-form-item>
           </el-col>
            <el-col :span="8">
          <el-form-item label="券库编号">
            <el-input v-model="page.coupGrpNo"></el-input>
          </el-form-item>
         </el-col>
            <el-col :span="8">
          <el-form-item label="券包名称">
            <el-input v-model="page.coupPacketName"></el-input>
          </el-form-item>
           </el-col>
           </el-row>
            <el-row :gutter="50">
            <el-col :span="8">
          <el-form-item label="券名称">
            <el-input v-model="page.couponsName"></el-input>
          </el-form-item>
          </el-col>
            <el-col :span="8">
          <el-form-item label="券编码">
            <el-input v-model="page.coupCode"></el-input>
          </el-form-item>
          </el-col>
            <el-col :span="8">
          <el-form-item label="券类型">
            <el-select style="width: 100%" v-model="page.couponsKind">
              <el-option
                :label="item.lable"
                :value="item.id"
                v-for="(item, index) in couponsKindType"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
         </el-col>
            </el-row>
          <el-row :gutter="50">
            <el-col :span="8">
          <el-form-item label="状态">
            <el-select style="width: 100%" v-model="page.state">
              <el-option
                :label="item.lable"
                :value="item.id"
                v-for="(item, index) in StateType"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          </el-col>
            <el-col :span="8">
          <el-form-item label="创建时间">
            <el-date-picker
              v-model="page.createDatePicker"
              type="daterange"
              start-placeholder="创始开始日期"
              end-placeholder="创始结束日期"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
           </el-col>
            <el-col :span="8">
          <el-form-item label="生效时间">
            <el-date-picker
              v-model="page.verityDarePicker"
              type="daterange"
              start-placeholder="生效开始日期"
              end-placeholder="生效结束日期"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
         </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never"
             class="pagesCard">
      <el-table class="table-style"
                border
                :height="PagesIsMore ? 'calc(100vh - 25.5rem)' : 'calc(100vh - 23rem)'"
                :row-class-name="tableRowClassName"
                :header-cell-style="{
          background: '#FCFBF2',
          color: '#6C6839',
          'text-align': 'center',
        }"
        :cell-style="{ 'text-align': 'center' }"
        ref="multipleTable"
        :data="SecuritiesList"
        tooltip-effect="dark"
        @select="dialogCheck"
        @selection-change="handleSelectionChange"
        v-el-table-infinite-scroll="PageTouchTheBottom"
        infinite-scroll-disabled="infiniteScrollDisabledIs"
        v-loading="page.Loading"
      >
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column prop="coupCode" width="260" label="券编码">
          <template slot-scope="scope">
            <div
              v-if="jurisdiction.look"
              class="ConponesName"
              @click="OnclickCouCode(scope.row)"
            >
              {{ scope.row.coupCode }}
            </div>
            <div v-else class="ConponesName">
              {{ scope.row.coupCode }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="couponsName" width="150" label="券名称">
          <template slot-scope="scope">
            <div
              v-if="jurisdiction.look"
              class="ConponesName"
              @click="OnclickConponesName(scope.row)"
            >
              {{ scope.row.couponsName }}
            </div>
            <div v-else class="ConponesName">
              {{ scope.row.couponsName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="innerCoupName"
          width="150"
          label="券后台名称"
        ></el-table-column>
        <el-table-column
          prop="coupPacketName"
          label="券包名称"
          width="150"
        ></el-table-column>
        <el-table-column prop="couponsKText" width="80" label="券类型">
        </el-table-column>
        <el-table-column prop="stateText" width="80" label="状态">
        </el-table-column>
        <el-table-column prop="custName" width="100" label="会员名称">
        </el-table-column>
        <el-table-column prop="cardNo" width="180" label="会员卡号">
        </el-table-column>
        <el-table-column prop="levelName" label="会员等级"> </el-table-column>
        <el-table-column prop="startDate" width="180" label="生效起始日期">
          <template slot-scope="scope">
            <div v-if="scope.row.startDate !== null">
              {{ scope.row.startDate | dateFormats }}
            </div>
            <div v-else></div>
          </template>
        </el-table-column>
        <el-table-column prop="endDate" width="180" label="生效终止日期">
          <template slot-scope="scope">
            <div v-if="scope.row.endDate !== null">
              {{ scope.row.endDate | dateFormats }}
            </div>
            <div v-else></div>
          </template>
        </el-table-column>
        <el-table-column prop="createUserName" width="100" label="创建人">
        </el-table-column>
        <el-table-column prop="createTimeStr" width="180" label="创建时间">
        </el-table-column>
        <el-table-column prop="updateUserName" width="100" label="最后修改人">
        </el-table-column>
        <el-table-column prop="udateTime" width="180" label="修改日期">
        </el-table-column>
      </el-table>
      <el-alert  v-if="PagesIsMore"
        title="没有更多数据了!"
        type="warning"
        center
        :closable="false"
      >
      </el-alert>
    </el-card>
  </div>
</template>

<script>
import {
  couponslist,
  couponsverity,
  couponsdisable,
  TApiLogsyncProcess,
} from "@/api/couponsDepot.js";
export default {
  name: "centre",
  data() {
    return {
      EnabledisableFormVisible: false,
      jurisdiction: {
        search: false,
        manual: false,
        disable: false,
        look: false,
        synchronizationn: false,
      },
      couponsKindType: [
        {
          lable: "全部",
          id: "",
        },
        {
          lable: "现金券",
          id: "0",
        },
        {
          lable: "折扣券",
          id: "1",
        },
        {
          lable: "礼品券",
          id: "2",
        },
        {
          lable: "异业券",
          id: "3",
        },
      ],
      StateType: [
        {
          lable: "全部",
          id: "",
        },
        {
          lable: "有效",
          id: "0",
        },
        {
          lable: "已核销",
          id: "1",
        },
        {
          lable: "已禁用",
          id: "2",
        },
        {
          lable: "未发放",
          id: "3",
        },
        {
          lable: "无效",
          id: "4",
        },
        {
          lable: "已过期",
          id: "5",
        },
      ],
      SecuritiesList: [], //卷库列表
      SelectChang: {}, //选择的行
      page: {
        createDatePicker: "",
        verityDarePicker: "",
        pageNo: 1,
        pageSize: 50,
        pages: 2,
        Loading: true,
        coupPacketName: "",
        coupGrpNo: "",
        couponsKind: "",
        couponsName: "",
        createEndDay: "",
        createStartDay: "",
        endVerityDate: "",
        startVerityDate: "",
        search: "",
        coupCode: "",
        state: "",
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      labelPosition: "right",
      num: 0,
    };
  },
  created() {
    let IssuedStamps = JSON.parse(localStorage.getItem("IssuedStamps"));
    for (let i = 0; i < IssuedStamps.length; i++) {
      if (IssuedStamps[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (IssuedStamps[i].menuName == "手工核销") {
        this.jurisdiction.manual = true;
        continue;
      }
      if (IssuedStamps[i].menuName == "禁用") {
        this.jurisdiction.disable = true;
        continue;
      }
      if (IssuedStamps[i].menuName == "同步") {
        this.jurisdiction.synchronizationn = true;
        continue;
      }
      if (IssuedStamps[i].menuName == "查看") {
        this.jurisdiction.look = true;
        continue;
      }
    }
    console.log(IssuedStamps);
  },
  computed: {
    PagesIsMore() {
      return this.page.pageNo >= this.page.pages;
    },
    infiniteScrollDisabledIs() {
      return this.page.Loading || this.PagesIsMore;
    },
  },
  mounted() {
    this.Rcouponslist();
  },
  methods: {
    Synchronization() {
      if (Object.keys(this.SelectChang).length <= 2) {
        this.$message({
          message: "请先选择数据,才能进行同步!",
          type: "warning",
        });
        return false;
      } else {
        this.EnabledisableFormVisible = true;
      }
    },
    Enabledisableqd() {
      let data = require("qs").stringify({
        id: this.SelectChang.coupID,
        type: 2,
      });
      TApiLogsyncProcess(data).then((res) => {
        if (res.success == true) {
          this.$message.success("同步成功");
          this.EnabledisableFormVisible = false;
          this.page.pageNo = 1;
          this.page.Loading = true;
          this.SecuritiesList = [];
          this.Rcouponslist();
        } else {
          this.$message.error("同步失败");
        }
      });
    },
    Disable() {
      if (Object.keys(this.SelectChang).length <= 2) {
        this.$message({
          message: "请先选择数据,才能禁用!",
          type: "warning",
        });
        return false;
      }
      this.$confirm("此操作将禁用该条记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = require("qs").stringify({
            coupID: this.SelectChang.coupID,
          });
          couponsdisable(data).then((res) => {
            console.log("res", res);
            if (res.success) {
              this.query();
              this.$message({
                type: "success",
                message: "禁用成功!",
              });
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消禁用",
          });
        });
    },
    WriteOff() {
      if (Object.keys(this.SelectChang).length <= 2) {
        this.$message({
          message: "请先选择数据,才能进行核销!",
          type: "warning",
        });
        return false;
      }
      this.$confirm("此操作将核销该条记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = require("qs").stringify({
            coupID: this.SelectChang.coupID,
          });
          couponsverity(data).then((res) => {
            if (res.success) {
              this.query();
              this.$message({
                type: "success",
                message: "核销成功!",
              });
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    OnclickConponesName(row) {
      row.couponsGrpID = row.couponsGrpID1;
      let obj = {
        couponsGrpID: row.couponsGrpID1,
      };
      this.$store.dispatch("user/USetCouponsSelectChang", obj);
      localStorage.setItem("CouponsSelectChang", JSON.stringify(obj));
      if (row.couponsKText == "现金券") {
        this.$router.push("/ViewDetails");
      } else if (row.couponsKText == "礼品券") {
        this.$router.push("/GiftLookup");
      } else if (row.couponsKText == "折扣券") {
        this.$router.push("/RebateDetails");
      } else if (row.couponsKText == "异业券") {
        this.$router.push("/AbnormalLook");
      }
    },
    OnclickCouCode(row) {
      this.SelectChang = row;
      this.see();
    },
    see() {
      if (Object.keys(this.SelectChang).length <= 2) {
        this.$message({
          message: "请先选择数据,才能进行查看!",
          type: "warning",
        });
        return false;
      }
      this.$store.dispatch("user/USetCouponsSelectChang", this.SelectChang);
      localStorage.setItem(
        "CouponsSelectChang",
        JSON.stringify(this.SelectChang)
      );
      this.$router.push("/IssuedSee");
    },
    renderTime(date) {
      //格式化时间
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
    query() {
      if (this.page.createDatePicker && this.page.createDatePicker.length > 0) {
        this.page.createStartDay = this.renderTime(
          this.page.createDatePicker[0]
        ).substring(0, 10);
        this.page.createEndDay = this.renderTime(
          this.page.createDatePicker[1]
        ).substring(0, 10);
      } else {
        this.page.createStartDay = "";
        this.page.createEndDay = "";
      }

      if (this.page.verityDarePicker && this.page.verityDarePicker.length > 0) {
        this.page.startVerityDate = this.renderTime(
          this.page.verityDarePicker[0]
        ).substring(0, 10);
        this.page.endVerityDate = this.renderTime(
          this.page.verityDarePicker[1]
        ).substring(0, 10);
      } else {
        this.page.startVerityDate = "";
        this.page.endVerityDate = "";
      }
      this.page.pageNo = 1;
      this.page.Loading = true;
      this.SecuritiesList = [];
      this.Rcouponslist();
    },
    Rcouponslist() {
      let data = require("qs").stringify({
        coupCode: this.page.coupCode,
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        coupPacketName: this.page.coupPacketName,
        coupGrpNo: this.page.coupGrpNo,
        couponsKind: this.page.couponsKind,
        couponsName: this.page.couponsName,
        createEndDay: this.page.createEndDay,
        createStartDay: this.page.createStartDay,
        startVerityDate: this.page.startVerityDate,
        endVerityDate: this.page.endVerityDate,
        search: this.page.search,
        state: this.page.state,
      });
      this.num++;
      let a = this.num;
      couponslist(data).then((res) => {
        if (res.success) {
          this.page.pages = res.data.pages;
          if (a == this.num) {
            res.data.list.forEach((item) => {
              item.couponsGrpID1 = item.couponsGrpID;
              item.couponsGrpID = item.coupID;
              item.createTimeStr = this.renderTime(item.createTime);
              item.stateText = this.returnStateText(parseInt(item.state));
              item.couponsKText = this.returncouponsKText(
                parseInt(item.couponsKind)
              );
            });
            this.SecuritiesList = this.SecuritiesList.concat(res.data.list);
          }
        } else {
          this.$message.error(res.message);
        }
        this.page.Loading = false;
      });
    },
    returncouponsKText(type) {
      let text = "";
      switch (type) {
        case 0:
          text = "现金券";
          break;
        case 1:
          text = "折扣券";
          break;
        case 2:
          text = "礼品券";
          break;
        case 3:
          text = "异业券";
          break;
      }
      return text;
    },
    returnStateText(type) {
      let text = "";
      switch (type) {
        case 0:
          text = "有效";
          break;
        case 1:
          text = "已核销";
          break;
        case 2:
          text = "已禁用";
          break;
        case 3:
          text = "未发放";
          break;
        case 4:
          text = "无效";
          break;
        case 5:
          text="已过期"
      }
      return text;
    },
    PageTouchTheBottom() {
      this.page.Loading = true;
      this.page.pageNo++;
      this.Rcouponslist();
    },
    dialogCheck(selection, row) {
      this.$refs.multipleTable.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.SelectChang = row;
        this.$refs.multipleTable.toggleRowSelection(row, true);
      }
    },
    handleSelectionChange(e) {
      if (e.length > 0) {
        this.SelectChang = e[e.length - 1];
      } else {
        this.SelectChang = {};
      }
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
  },
};
</script>
<style lang="scss" scoped>
.ConponesName {
  text-decoration: underline;
  color: #a19b59;
}
.ConponesName:hover {
  cursor: pointer;
}
.pagesCard {
  margin-top: 10px;
}
.header-text {
  height: 50px;
  line-height: 50px;
  color: #76734f;
}

// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
/deep/input {
  border-radius: 0;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

::v-deep {
  .el-table .warning-row {
    background: #fcfbf2;
  }
  .el-table .success-row {
    background: #ffffff;
  }
  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
}
/deep/.Enabledisable {
  .el-dialog__header,
  .el-message-box__header {
    border-top-left-radius: 9px;
    border-top-right-radius: 9px;
    height: 44px;
    background: #f3f1dd;
    width: 100%;
    text-align: center;
    color: #666;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    box-sizing: border-box;
  }
  .el-dialog__title,
  .el-message-box__title {
    color: #6c6937;
    font-weight: 700;
    font-size: 16px !important;
  }
  .el-dialog .el-dialog__body {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .coverage-release .el-dialog__body {
    padding: 20px;
  }
  .el-button:hover {
    background-color: #b6b388;
  }
  .el-dialog__body {
    padding: 30px 60px;
  }
  .el-tabs__item {
    border: 1px solid #d9d9d9;
    background-color: #fff;
    color: #6c6937;
  }
  .el-dialog__footer {
    height: 60px;
    text-align: center;
    background-color: #f2f2f2;
  }

  .el-tabs__item.is-active {
    color: #6c6937;
    background-color: #f3f1dd;
  }
  .el-form-item__content {
    line-height: 0px;
  }
  .el-textarea__inner {
    // 取消拉伸样式
    resize: none;
  }
}
</style>
